import { gql } from '@apollo/client';

export const USER_CREATE_SELF = gql`
  mutation userCreateSelf($input: InputUserCreateSelf!) {
    userCreateSelf(input: $input) {
      message
    }
  }
`;

export const USER_CHECK_CAPTCHA = gql`
  mutation userCheckCaptcha($input: InputCaptchaCheck!) {
      userCheckCaptcha(input: $input) {
      message
    }
  }
`;

export const USER_UPDATE_SELF = gql`
  mutation userUpdateAccountSelf($input: InputUserAccountUpdateSelf!) {
    userUpdateAccountSelf(input: $input) {
      message
    }
  }
`;

export const USER_UPDATE_SELF_PHONE = gql`
  mutation userUpdatePhoneSelf($input: InputUserUpdateSelfPhone!) {
    userUpdatePhoneSelf(input: $input) {
      message
    }
  }
`;

export const USER_AC_RESET = gql`
  mutation resetPassword($input: InputPasswordReset!) {
    resetPassword(input: $input) {
      message
    }
  }
`;

export const USER_AC_RECOVER = gql`
  mutation recoverAccount($input: InputRecoverAccount!) {
    recoverAccount(input: $input) {
      message
    }
  }
`;

export const USER_LOGIN = gql`
  mutation login($input: InputLogin!) {
    login(input: $input) {
      message
    }
  }
`;

export const USER_GOOGLE_AUTH = gql`
  mutation googleAuth($input: InputGoogleAuth!) {
    googleAuth(input: $input) {
      message
    }
  }
`;

export const USER_LOGOUT = gql`
  mutation logout {
    logout {
      message
    }
  }
`;

export const USER_LOCK = gql`
  mutation sessionLock {
    sessionLock {
      message
    }
  }
`;

export const USER_UN_LOCK = gql`
  mutation sessionUnlock($input: InputUnlock!) {
    sessionUnlock(input: $input) {
      message
    }
  }
`;

export const USER_RECYCLE = gql`
  mutation userRecycle($input: InputIds!) {
    userRecycle(input: $input) {
      message
    }
  }
`;

export const USER_RESTORE = gql`
  mutation userRestore($input: InputIds!) {
    userRestore(input: $input) {
      message
    }
  }
`;

export const USER_SUSPEND = gql`
  mutation userSuspend($input: InputUserStateChange!) {
    userSuspend(input: $input) {
      message
    }
  }
`;

export const USER_ACTVATE = gql`
  mutation userActivate($input: InputIds!) {
    userActivate(input: $input) {
      message
    }
  }
`;

export const USER_CREATE_ALIEN = gql`
  mutation userCreateAlien($input: InputUserCreateAlien!) {
    userCreateAlien(input: $input) {
      message
    }
  }
`;

export const USER_UPDATE_ROLE = gql`
  mutation userRoleUpdate($input: InputUserRoleUpdate!) {
    userRoleUpdate(input: $input) {
      message
    }
  }
`;

export const M_USERS_MINI = gql`
  mutation m_usersActive($input: InputUsers!) {
    m_usersActive(input: $input) {
      count
      rows {
        id
        name
        email
      }
    }
  }
`;
export const M_USERS_MINI_WITH_ROLE = gql`
  mutation m_usersActive($input: InputUsers!) {
    m_usersActive(input: $input) {
      count
      rows {
        id
        name
        email
        role {
          id
          name
        }
      }
    }
  }
`;

export const M_USERS_ACTIVE = gql`
  mutation m_usersActive($input: InputUsers!) {
    m_usersActive(input: $input) {
      count
      rows {
        index
        id
        name
        accountNo
        phone
        email
        state
        created
        role {
          name
        }
        profile {
          photo {
            fileName
          }
        }
      }
    }
  }
`;

export const M_USERS_RECYCLED = gql`
  mutation m_usersRecycled($input: InputUsers!) {
    m_usersRecycled(input: $input) {
      count
      rows {
        index
        id
        name
        accountNo
        phone
        email
        state
        created
        role {
          name
        }
        profile {
          photo {
            fileName
          }
        }
      }
    }
  }
`;

export const M_USER = gql`
  mutation user($input: InputId!) {
    user(input: $input) {
      id
      name
      role {
        id
        name
      }
    }
  }
`;

export const USER_AGENT_PROFILE = gql`
  mutation agentProfile {
    agentProfile {
      id
      preferredLocationId
      preferredLocations {
        id
        source
        locationId
        label
        latitude
        longitude
      }
      workOutsideCounty
      travelDistanceWilling
      jobTypePreferred
      workSchedulePreferred
      workingHoursPreferred
      multidayAssignments
      sameDayJobs
      highestEducationLevel
      yearsOfWorkExperience
      digitalSkills
      experienceAreas
      resumeFile
      phoneType
      internetAccess
      connectivityIssues
      hearAboutUs
      consent
      photo {
        fileName
      }
        userId
    }
  }
`;

export const USER_AGENT_LOCATION_STATUS = gql`
  mutation agentProfileLocationStatus {
    agentProfile {
      preferredLocations {
        source
      }
    }
  }
`;

export const USER_FRAUD_FLAG_ADD = gql`
  mutation userFraudFlagAdd($input: InputUserFraudFlagAdd!) {
    userFraudFlagAdd(input: $input) {
      message
      reference
    }
  }
`;

export const USER_FRAUD_FLAG_UPDATE = gql`
  mutation userFraudFlagUpdate($input: InputUserFraudFlagUpdate!) {
    userFraudFlagUpdate(input: $input) {
      message
    }
  }
`;

export const USER_FRAUD_FLAG_REMOVE = gql`
  mutation userFraudFlagRemove($input: InputId!) {
    userFraudFlagRemove(input: $input) {
      message
    }
  }
`;

export const M_AGENT_RISK_PROFILES = gql`
  mutation agentRiskProfiles($input: InputIds!) {
    agentRiskProfiles(input: $input) {
      userId
      fraudFlags
      globalScore
      profileCompleteness
      experienceScore
      skillScore
      deviceScore
      completionRate
    }
  }
`;

// export const Q_USERS_ACTIVE = gql`
//   query usersActive($input: InputUsers!) {
//     usersActive(input: $input) {
//       count
//       rows {
//         index
//         id
//         name
//         accountNo
//         phone
//         email
//         state
//         created
//         role {
//           name
//         }
//         profile {
//           photo {
//             fileName
//           }
//         }
//       }
//     }
//   }
// `;

// export const Q_USERS_RECYCLED = gql`
//   query usersRecycled($input: InputUsers!) {
//     usersRecycled(input: $input) {
//       count
//       rows {
//         index
//         id
//         name
//         accountNo
//         phone
//         email
//         state
//         recycled
//         role {
//           name
//         }
//         profile {
//           photo {
//             fileName
//           }
//         }
//       }
//     }
//   }
// `;
